
import React from 'react';
import { FacilityOrderNewFlowInventoryCalculationVerificationModalTemplate } from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowInventoryCalculationVerificationModalStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowInventoryCalculationVerificationModalStore(rootStore, componentProps), 'facilityOrderNewFlowInventoryCalculationVerificationModalStore')
@observer
class FacilityOrderNewFlowInventoryCalculationVerificationModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowInventoryCalculationVerificationModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowInventoryCalculationVerificationModal;
